
import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import dealModule from '@/store/deal'
import DealEditor from '@/components/company/deal/DealEditor.vue'
import DealCommentsDialog from '@/components/company/deal/DealCommentsDialog.vue'
import DealStatisticsDialog from '@/components/company/deal/DealStatisticsDialog.vue'
import Axios from 'axios'
import whitelabel from '@/store/whitelabel'

function downloadData(data: Blob, filename: string) {
  // create file link in browser's memory
  const href = URL.createObjectURL(data)

  // create "a" HTML element with href to file & click
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', filename) //or any other extension
  document.body.appendChild(link)
  link.click()

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

@Component({
  name: 'DealDetail',
  components: {
    DealEditor,
    DealCommentsDialog,
    DealStatisticsDialog
  }
})
class DealDetail extends Vue {
  private showCommentsDialog = false
  private showStatisticsDialog = false

  private get deal() {
    return dealModule.deal
  }

  private get isPartner(): boolean {
    return authModule.isPartner
  }

  async downloadCodes() {
    const { data } = await Axios.get(
      `/admin/${whitelabel.whitelabel.slug}/deals/${this.deal?._id}/codes`,
      {
        responseType: 'blob'
      }
    )

    downloadData(data, 'codes.csv')
  }

  async downloadRedemptions() {
    const { data } = await Axios.get(
      `/admin/${whitelabel.whitelabel.slug}/deals/${this.deal?._id}/redemptions`,
      {
        responseType: 'blob'
      }
    )

    downloadData(data, 'redemptions.csv')
  }
}

export default DealDetail
